// For the tracking with AdCell https://www.adcell.de/merchant/tracking#
export const programmId = "7725";
export const eventIdInvest = "9878";
export const eventIdRegister = "9879";
